import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3758fbd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Nueva contraseña", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Ya tienes tu contraseña nueva. Entra con ella.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, " Este enlace no vale. Pide otro desde «¿Desea recordar la contraseña?» en la pantalla de inicio de sesión. ", -1))

import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "axios";
import { restablecerContrasena } from "@/services/UsuariosService";


export default /*#__PURE__*/_defineComponent({
  __name: 'RestablecerContrasenaView',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const enLaUrl = route.query.token;
const token = ref(typeof enLaUrl === "string" ? enLaUrl : "");
const nueva = ref("");
const repetida = ref("");
const guardando = ref(false);
const cambiada = ref(false);
const error = ref("");

const reglaObligatoria = (valor: string) =>
  !!valor || "Este campo es obligatorio";
const reglaLongitud = (valor: string) =>
  (valor.length >= 6 && valor.length <= 100) ||
  "La contraseña debe tener entre 6 y 100 caracteres";
const reglaIguales = (valor: string) =>
  valor === nueva.value || "Las contraseñas no coinciden";

const esValido = computed(
  () => reglaLongitud(nueva.value) === true && nueva.value === repetida.value
);

onMounted(() => {
  // Fuera de la barra de direcciones y del historial: el enlace es como una contraseña de un solo uso
  if (enLaUrl) router.replace({ query: {} });
});

// Con la app abierta en esta página puede llegar otro enlace del correo: vale el último
watch(
  () => route.query.token,
  (otro) => {
    if (typeof otro !== "string" || !otro) return;
    token.value = otro;
    cambiada.value = false;
    error.value = "";
    router.replace({ query: {} });
  }
);

const guardar = async () => {
  if (!esValido.value) return;
  error.value = "";
  guardando.value = true;
  try {
    await restablecerContrasena({ token: token.value, nuevaPass: nueva.value });
    cambiada.value = true;
  } catch (e) {
    error.value =
      (axios.isAxiosError(e) && e.response?.data?.message) ||
      "No se ha podido cambiar la contraseña. Prueba otra vez en un rato.";
  } finally {
    guardando.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "restablecer" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  (cambiada.value)
                    ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                        default: _withCtx(() => [
                          _hoisted_2,
                          _createVNode(_component_v_btn, {
                            color: "blue darken-1",
                            variant: "tonal",
                            size: "large",
                            block: "",
                            to: { name: 'inicio-sesion' }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Iniciar sesión ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (!token.value)
                      ? (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                          default: _withCtx(() => [
                            _hoisted_3,
                            _createVNode(_component_v_btn, {
                              color: "blue darken-1",
                              variant: "tonal",
                              size: "large",
                              block: "",
                              to: { name: 'inicio-sesion' }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Ir a iniciar sesión ")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_card_text, { key: 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_form, {
                              onSubmit: _withModifiers(guardar, ["prevent"])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: nueva.value,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nueva).value = $event)),
                                  label: "Nueva contraseña",
                                  type: "password",
                                  autocomplete: "new-password",
                                  rules: [reglaObligatoria, reglaLongitud],
                                  class: "my-2"
                                }, null, 8, ["modelValue", "rules"]),
                                _createVNode(_component_v_text_field, {
                                  modelValue: repetida.value,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((repetida).value = $event)),
                                  label: "Repite la nueva contraseña",
                                  type: "password",
                                  autocomplete: "new-password",
                                  rules: [reglaObligatoria, reglaIguales],
                                  class: "my-2"
                                }, null, 8, ["modelValue", "rules"]),
                                (error.value)
                                  ? (_openBlock(), _createBlock(_component_v_alert, {
                                      key: 0,
                                      type: "error",
                                      variant: "tonal",
                                      density: "compact",
                                      class: "mb-4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(error.value), 1)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_btn, {
                                  type: "submit",
                                  color: "blue darken-1",
                                  variant: "tonal",
                                  size: "large",
                                  block: "",
                                  loading: guardando.value,
                                  disabled: guardando.value || !esValido.value
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Guardar contraseña ")
                                  ]),
                                  _: 1
                                }, 8, ["loading", "disabled"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})